module.exports = __webpack_public_path__ + "static/media/18.d6a5b9ff.jpg";